import React from "react";
import { Typography, TextField, Avatar, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  brand: string;
  isHideTitle?: boolean;
};

const CompanyHeader = (props: Props) => {
  const { brand, isHideTitle } = props;
  const classes = useStyles();
  const _pm = require("../icons/perfectMedical.png");
  const _goku = require("../icons/goku.png");
  
  return (
    <div className={`${classes.portion} companyHeaderContainer`}>
      <div className={classes.headerContent}>
        <div className={classes.logoSection}>
          <Avatar
            alt=""
            src={brand === "PM" ? _pm : _goku}
            className={`${classes.avatar} companyHeaderAvatar`}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: 15,
            }}
          >
            <Typography className={`${classes.companyTitle} companyHeaderTitle`}>{`PERFECT ${
              brand === "PM" ? "MEDICAL" : "GOKU"
            }`}</Typography>
            <Typography className={`${classes.companySubtitle} companyHeaderSubtitle`}>
              {brand !== "PM"
                ? `PERFECT GOKU MANAGEMENT LIMITED`
                : `PERFECT SHAPE (HOLDINGS) LIMITED`}
            </Typography>
          </div>
        </div>
        <div className={classes.formSection}>
          {!isHideTitle && (
            <Typography
              className={classes.formTitle}
            >{`員工個人資料表格`}</Typography>
          )}
        <Box className={`${classes.confidentialText} confidentialText`}>
           Confidential
        </Box>
          
        </div>
      </div>
    </div>
  );
};

export default CompanyHeader;

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.pdfStyle.companyHeaderContainer': {
      '& .companyHeaderAvatar': {
        width: '50px',
        height: '50px',
      },
      '& .companyHeaderTitle': {
        fontSize: '18px',
      },
      '& .companyHeaderSubtitle': {
        fontSize: '14px',
      },
      '& .confidentialText': {
        height: '35px',
      },
    },
  },
  container: {
    height: "100vh",
    borderRadius: "10rem",
  },
  mainBody: {
    display: "flex",
    flexDirection: "column",
    width: "90%",
    padding: "2rem",
    borderRadius: "1rem",
  },
  companyTitle: {
    textDecoration: "underline",
    color: "#454C96",
    fontWeight: 400,
    [theme.breakpoints.up("md")]: {
      fontSize: "36px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  companySubtitle: {
    color: "#505050",
    fontWeight: 600,
    [theme.breakpoints.up("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
  formTitle: {
    color: "#505050",
    fontWeight: 400,
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      fontSize: "24px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
    },
  },
  input: {
    margin: theme.spacing(1, 0),
  },
  confidentialText: {
    color: "#84909F",
    fontWeight: 400,
    letterSpacing: "0.04em",
    textAlign: "center",
    border: "1px solid #84909F",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "45px",
    [theme.breakpoints.up("md")]: {
      fontSize: "20px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "10px",
      height: "25px",
    },
  },
  inputValue: {
    width: "35%",
  },
  customOutlinedInput: {
    padding: "12px 14px",
  },
  portion: {
    padding: "10px 0px",
  },
  headerContent: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    '@media print': {
      flexDirection: 'row-reverse',
    }
  },
  logoSection: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-start",
      order: 2,
    },
  },
  formSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-end",
      order: 1,
      alignItems: "center",
    },
  },
  avatar: {
    width: "60px",
    height: "60px",
    [theme.breakpoints.up("md")]: {
      width: "93px",
      height: "93px",
    },
  },
}));
